import { useMemo } from "react";
import { Collection, CollectionItem, FullItems, Video } from "@/api";
import { ITEM_TYPE_COLLECTION, ITEM_TYPE_VIDEO } from "@/const.ts";
import { useMainTabs } from "@/hooks";

export const useFullItemsMainTab = (items: CollectionItem[]) => {
  const { collectionsById, videosById } = useMainTabs();

  // Find a full copy of each Collection and Video to be displayed
  const fullItems = useMemo(() => {
    if (!videosById || !collectionsById) {
      return {} as FullItems;
    }

    const videos: Record<number, Video> = {};
    const collections: Record<number, Collection> = {};
    for (const i of items ?? []) {
      const itemId = parseInt(i.ChildId);
      if (i.Type == ITEM_TYPE_VIDEO) {
        videos[itemId] = videosById[itemId];
      }
      if (i.Type == ITEM_TYPE_COLLECTION) {
        collections[itemId] = collectionsById[itemId];
      }
    }
    return { videos, collections };
  }, [videosById, collectionsById, items]);

  return { fullItems };
};
